  document.addEventListener('DOMContentLoaded', initializeProductInteractions);
  document.addEventListener('ProductGridRendered', initializeProductInteractions);


  function initializeProductInteractions() {
    const transitionDelay = 0;
    let products_have_variation_pills = false;
    const main_content = document.querySelector('#MainContent');
    const product_cards = document.querySelectorAll('.card-product__container');


    product_cards.forEach(function (product_card, product_index){
      const og_product_id = product_card.getAttribute('data-og-product-id');
      const cardoverlays = product_card.querySelectorAll('.card-wrapper .card__inner');

      cardoverlays.forEach(function (cardoverlay, overlay_index) {
        const qaContainer = cardoverlay.querySelector('.quick-add__sizes');
        const qa_button = qaContainer.querySelector('.product-form button');
        const qa_pillcontainer = qaContainer.querySelector('.product-variants');

        cardoverlay.addEventListener('mouseenter', function() {
            cardoverlay.classList.add('active');
        });

        cardoverlay.addEventListener('mouseleave', function() {
            cardoverlay.classList.remove('active');
            qaContainer.classList.remove('active');
        });

        qa_button.addEventListener('mouseenter', () => {
            qaContainer.classList.add('active');
        });

        const variantPills = qa_pillcontainer.querySelectorAll('.variant-pill');
        const formInput = qaContainer.querySelector('input[name="id"]');
        const submitButton = qaContainer.querySelector('button[name="add"]');
        
        variantPills.forEach(function(variantPill) {
            variantPill.addEventListener('click', function(e) {
            if (!this.classList.contains('disabled')) {
              const variantId = this.dataset.variantId;
              formInput.value = variantId;
              submitButton.click();
            }
          });
        });

      });


      const pills = product_card.querySelectorAll('.product-pills-container .pill');
      if (pills && pills.length > 0) {
        products_have_variation_pills = true;

  
        pills.forEach(function (pill) {
            pill.addEventListener('click', function (e) {
                const data_index = parseInt(pill.getAttribute('data-slide-index'));
                const product_variations = product_card.querySelectorAll('.card-wrapper'); 
    
                for (let i = 0; i < product_variations.length; i++) {
                    product_variations[i].classList.remove('active');
                    pills[i].classList.remove('active');
                }
    
                setTimeout(function () {
                    product_variations[data_index].classList.add('active');
                    pills[data_index].classList.add('active');
                }, transitionDelay);
            });
        });
      } 


    });

    if (products_have_variation_pills) {
        main_content.classList.add('product_cards-with-pills');
    }
    else {
        main_content.classList.remove('product_cards-with-pills');
      }

  }

